var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalCancelamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "450px",
    height: "78px",
    viewBox: "0 0 450 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "82AECBEF-FD50-4C2D-A313-BF10CA2952DF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desk",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plano---cancelar-assinatura/modal-usu\\xE1rio-desisitu-de-cancelar",
    transform: "translate(-497.000000, -452.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "confetes",
    transform: "translate(497.000000, 452.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(128.000000, 39.500000) scale(-1, -1) translate(-128.000000, -39.500000) translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(173.000000, 36.000000) scale(-1, -1) translate(-173.000000, -36.000000) ",
    cx: 173,
    cy: 36,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(33.000000, 59.000000) scale(-1, -1) translate(-33.000000, -59.000000) ",
    cx: 33,
    cy: 59,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(190.000000, 12.000000) scale(-1, -1) translate(-190.000000, -12.000000) ",
    cx: 190,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(248.000000, 4.000000) scale(-1, -1) translate(-248.000000, -4.000000) ",
    cx: 248,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(246.000000, 32.000000) scale(-1, -1) translate(-246.000000, -32.000000) ",
    cx: 246,
    cy: 32,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    transform: "translate(169.000000, 64.000000) scale(-1, -1) translate(-169.000000, -64.000000) ",
    cx: 169,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    transform: "translate(150.000000, 32.000000) scale(-1, -1) translate(-150.000000, -32.000000) ",
    cx: 150,
    cy: 32,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    transform: "translate(60.000000, 55.000000) scale(-1, -1) translate(-60.000000, -55.000000) ",
    cx: 60,
    cy: 55,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    transform: "translate(188.000000, 49.000000) scale(-1, -1) translate(-188.000000, -49.000000) ",
    cx: 188,
    cy: 49,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    transform: "translate(2.000000, 48.000000) scale(-1, -1) translate(-2.000000, -48.000000) ",
    cx: 2,
    cy: 48,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    transform: "translate(212.000000, 14.000000) scale(-1, -1) translate(-212.000000, -14.000000) ",
    cx: 212,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(196.000000, 66.000000) scale(-1, -1) translate(-196.000000, -66.000000) ",
    cx: 196,
    cy: 66,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(158.000000, 49.000000) scale(-1, -1) translate(-158.000000, -49.000000) ",
    cx: 158,
    cy: 49,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(84.000000, 45.000000) scale(-1, -1) translate(-84.000000, -45.000000) ",
    cx: 84,
    cy: 45,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(167.000000, 16.000000) scale(-1, -1) translate(-167.000000, -16.000000) ",
    cx: 167,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 229,
    cy: 69,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 90,
    cy: 71,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 233,
    cy: 41,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 252,
    cy: 73,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 210,
    cy: 52,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 202,
    cy: 35,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    transform: "translate(143.000000, 69.000000) scale(-1, -1) translate(-143.000000, -69.000000) ",
    cx: 143,
    cy: 69,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    transform: "translate(110.000000, 54.000000) scale(-1, -1) translate(-110.000000, -54.000000) ",
    cx: 110,
    cy: 54,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    transform: "translate(134.000000, 53.000000) scale(-1, -1) translate(-134.000000, -53.000000) ",
    cx: 134,
    cy: 53,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 115,
    cy: 69,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 240,
    cy: 52,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(326.500000, 34.000000) scale(-1, 1) translate(-326.500000, -34.000000) translate(203.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 27,
    cy: 36,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 44,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 92,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 114,
    cy: 33,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 23,
    cy: 64,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 4,
    cy: 32,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 8,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 42,
    cy: 49,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 66,
    cy: 14,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 168,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 50,
    cy: 66,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 12,
    cy: 49,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 21,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 150,
    cy: 28,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 87,
    cy: 41,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 150,
    cy: 8,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 184,
    cy: 6,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 114,
    cy: 10,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FF9E17",
    cx: 64,
    cy: 52,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 56,
    cy: 35,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 81,
    cy: 25,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 135,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 202,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 245,
    cy: 6,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#21C5E5",
    cx: 94,
    cy: 52,
    r: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCancelamento);
export default __webpack_public_path__ + "static/media/modal-cancelamento.2ad6d75e36db7ab2f0de6fb410c97803.svg";
export { ForwardRef as ReactComponent };